import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css'; // We'll create this CSS file

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear error for this field when user starts typing
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Name must be at least 2 characters';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.subject.trim()) {
      newErrors.subject = 'Subject is required';
    }
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitMessage('');

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);

    try {
      await emailjs.send(
        'service_pavxg5z',
        'template_mfdsaso',
        formData,
        'uoWa4JTFIt4rv5j4_'
      );
      setSubmitMessage('Thank you for your message! We\'ll get back to you soon.');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitMessage('Sorry, there was an error sending your message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div id="contact" className="contact-container">
      <h1>Get in Touch with Bubbles!</h1>
      <p className="contact-intro">
        We'd love to hear from you! Whether you have questions about enrollment, our programs,
        or just want to say hello, feel free to reach out.
      </p>

      <div className="contact-info-grid">
        <div className="info-card">
          <h3>Visit Us</h3>
          <p>All Mart, Bisrate Gebriel, Addis Ababa</p>
          <p>
            <a href="https://www.google.com/maps/dir/?api=1&destination=All%20Mart,%20Bisrate%20Gebriel,%20Addis%20Ababa" target="_blank" rel="noopener noreferrer">
              Get directions
            </a>
          </p>
        </div>
        <div className="info-card">
          <h3>Call Us</h3>
          <p>Phone: <a href="tel:+251948883388">+251 948 88 33 88</a> | <a href="tel:+251940880055">+251 940 88 00 55</a></p>
        </div>
        <div className="info-card">
          <h3>Email Us</h3>
          <p>Email: <a href="mailto:bubblesearlyyears25@gmail.com">bubblesearlyyears25@gmail.com</a></p>
        </div>
      </div>

      <div className="contact-form-section">
        <h2>Send Us a Message</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Your Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            {errors.name && <span className="error">{errors.name}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="email">Your Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject:</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            />
            {errors.subject && <span className="error">{errors.subject}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="message">Your Message:</label>
            <textarea
              id="message"
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            {errors.message && <span className="error">{errors.message}</span>}
          </div>
          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
        {submitMessage && <div className={`submit-message ${submitMessage.includes('Thank you') ? 'success' : 'error'}`}>{submitMessage}</div>}
      </div>

      <div className="map-section">
        <h2>Find Us on the Map</h2>
        {/* Clickable map container */}
        <div className="map-placeholder">
          <a
            href="https://www.google.com/maps?q=Bubbles+Early+Years+School+Addis+Ababa"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block', cursor: 'pointer' }}
            title="Click to open in Google Maps"
          >
            <iframe
              src="https://maps.google.com/maps?q=Bubbles+Early+Years+School+Addis+Ababa&output=embed"
              width="100%"
              height="450"
              style={{ border: 0, pointerEvents: 'none' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="School Location - Click to open in Google Maps"
            ></iframe>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;